namespace GeniuzPOS.InventoryReport {
    export enum ConsignFg {
        ApproveFgSelect = 0,
        ApproveFgSelect1 = 1
    }
    Serenity.Decorators.registerEnumType(ConsignFg, 'GeniuzPOS.InventoryReport.ConsignFg', 'InventoryReport.ConsignFg');
}
